<template>
  <div class="wrapper">
    <div class="header">
      <div class="buttons">
        <router-link to="/cart" class="back">
          <vk-icon icon="triangle-left" ratio="2"></vk-icon>
        </router-link>
        <span>決済URL発行依頼</span>
      </div>
    </div>
    <div class="content" v-if="!ordered && !cart.length">
      <p>カートが空です。TOPに戻ってやり直すか、すでに発行された決済URLをメールでお送りいただいておりますかご確認ください。</p>
      <div class="mt-4 center-block">
        <button class="btn btn-secondary w-50" @click="$router.push('/')">TOPページへ</button>
      </div>
    </div>
    <div class="content" v-if="!mailSend && cart.length">
      <p>ご注文頂きます商品（{{ order.price | money }}/送料込み）をヤフオクにて出品いたします。出品ができ次第、商品のURLをご連絡させて頂きますので、そちらを落札の上、決済願います。
      決済の準備までしばらくお待ち願います。</p>

      <p>よろしければ、メールアドレスを入力の上、決済URL発行依頼ボタンを押してください。</p>

      <form action="uk-form">
        <div class="form-group">
          <label class="uk-form-label">メールアドレス</label>
          <div class="uk-form-controls"><input type="text" class="form-control" v-model="email"></div>
          <div class="text-danger" v-show="error">メールアドレスを入力ください</div>
        </div>
      </form>

      <p>※決済にはヤフオクのアカウントが必要となります。ご利用のアカウントにて落札の上、決済頂きます。</p>
      <p>※ドメイン指定している場合は、@harigu.comを受信できるようにしてからご利用ください。</p>

      <div class="center-block" v-if="order.code">
        <button class="btn btn-danger w-50" @click="mailTo">決済URL発行依頼</button>
      </div>
    </div>

  </div>
</template>

<script>
  import axios from 'axios';

export default {
    name: 'PaymentConfirm',
    data () {
      return {
        email: '',
        error: false,
        mailSend: false,
        ordered: false,
        order: {
          id: null,
          code: null,
          email: null,
        },
      };
    },
    created () {
      if (this.cart.length) {
        this.initialize();
      }
    },
    computed: {
      cart () {
        return this.$store.state.cart;
      }
    },
    methods: {
      async initialize () {
        this.$store.commit('setLoading');
        const response = await axios.post('http://admin.harigu.com/api/order', {
          payment_method: this.$route.params.payment_method,
          cart: this.cart
        });
        // console.log(response.data);
        // console.log(this.$store.state);
        this.order = response.data;
        this.$store.commit('setOrder', this.order);
        this.$store.commit('resetLoading');
        // const cart_ids = this.$store.state.cart.map(cart => cart.id);
        // console.log(cart_ids);
        // // カートのorder_idを更新する
        // await axios.put('http://admin.harigu.com/api/cart', {
        //   payment_method: this.$route.params.payment_method
        // });
      },
      clickDelete () {
      },
      clickChange () {
      },
      async mailTo () {
        if (!/.+@.+$/.test(this.email))
        {
          this.error = true;
          return false;
        }
        this.$store.commit('setLoading');
        const response = await axios.put('http://admin.harigu.com/api/order/' + this.order.code, {
          email: this.email,
          action: 'orderNotify',
        });
        window.console.log(response);
        this.$store.commit('setOrder', {
          id: response.data.order.id,
          code: response.data.order.code,
          email: this.email,
        });
        this.$store.commit('resetCart');
        this.$store.commit('resetLoading');
        // this.mailSend = true;
        // window.scrollTo(0, 0);
        this.$router.push('./done');
      }
    }
  };
</script>

<style scoped lang="scss">
  .content {
    padding: 1rem;
  }
  .header {
    position: sticky;
    position: -webkit-sticky;
    top: 48px;
    z-index:999;
  }
  .buttons {
    background-color: rgb(128, 127, 128);
    color: #fff;
    font-weight: bold;
    overflow: hidden;
    .back {
      color: rgb(240, 240, 240) !important;
      float: left;
      display: block;
    }
    span {
      float: right;
      display: block;
      padding-right: 10px;
      line-height: 40px;
    }
  }
  .center-block {
    text-align: center;
  }
  .btn {
    color: #f0f0f0;
    border-radius: .5em;
  }

  .payments {
    text-align:center;
  }
</style>
